export const initAccordion = (): void => {
  const url = location.href;

  const updateBtnText = (el: HTMLElement, isOpen: boolean) => {
    const btn = el.querySelector('.entry-index-btn');
    if (btn) {
      btn.textContent = isOpen ? '閉じる －' : '開く ＋';
    }
  };

  const toggleAccordion = (el: HTMLElement, force?: boolean) => {
    // force引数があればそれに従い、なければ反転させる
    const shouldOpen = force !== undefined ? force : !el.classList.contains('is-open');
    const content = el.nextElementSibling as HTMLElement;

    if (shouldOpen) {
      el.classList.add('is-open');
      content?.classList.add('is-open');
    } else {
      el.classList.remove('is-open');
      content?.classList.remove('is-open');
    }
    updateBtnText(el, shouldOpen);
  };

  // 1. クリックイベント
  const triggers = document.querySelectorAll<HTMLElement>('.js-accordion-01');
  triggers.forEach(trigger => {
    // 初期状態のテキストを現在のクラスに合わせてセットしておく（2回クリック防止）
    updateBtnText(trigger, trigger.classList.contains('is-open'));

    trigger.addEventListener('click', () => {
      toggleAccordion(trigger);
    });
  });

  // 2. URLアンカーによる初期展開
  if (url.indexOf("#") >= 0) {
    const id = url.split('#')[1];
    const target = document.querySelector(`#${id} > .js-accordion-01`) as HTMLElement;
    if (target) toggleAccordion(target, true);
  }
};